<template>
    <div id="Container" class="widget-container background--card new-card-layout">
        <a href="#" @click.prevent="closeSelf" class="close">
            <svg-rndr :width="16" :height="16" svg="close.svg" />
        </a>
        <div class="widget-contents DialogContent DialogContent--max">
            <div class="widget-contents__inner DialogContentInner card card-new">
                <div class="card-header">
                    <div class="form-row justify-content-center">
                        <div class="col-md-auto py-4">
                            <h1 v-translate>Password Reset</h1>
                        </div>
                    </div>
                </div>

                <div class="card-body px-2 px-sm-0" :class="hasScroll">
                    <form ref="form" method="POST" :action="$laraRoute('widget.reset-password')" @submit.prevent="handleForm" aria-label="Reset Password" novalidate>

                        <div class="form-group form-row justify-content-center align-items-center">
                            <div class="col-md-3">
                                <label for="password" v-translate>Current Password</label>
                            </div>

                            <div class="col-md-6">
                                <input v-validate="'required'" :data-vv-as="'current password' | translate" id="current_password" :type="currentPwordHidden ? 'password' : 'text'" class="form-control" name="current_password" :disabled="formSubmitting ? true : false" v-model="current_password" required>
                                <InlineError :errors="errors" type="current_password" />

                                <div tabindex="0" class="eye-container" @click="toggleCurrentPassword" @keyup.enter.space="toggleCurrentPassword" aria-label="Reveals or hides password">
                                    <object tabindex="-1" v-show="currentPwordHidden" data="/img/eye.svg" type="image/svg+xml" alt="Password hidden"></object>
                                    <object tabindex="-1" v-show="!currentPwordHidden" data="/img/eye-filled.svg" type="image/svg+xml" alt="Password revealed"></object>
                                </div>
                            </div>
                        </div>

                        <PasswordHandler :reset="true" :formRow="true"/>
                    </form>
                </div>

                <div class="card-footer">
                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <flash-message></flash-message>
                        </div>
                    </div>

                    <div class="form-group form-row justify-content-center">
                        <div class="col-auto">
                            <a class="link d-block mt-3" href="#" @click.prevent="closeSelf" v-translate>Cancel</a>
                        </div>
                        <div class="col-auto ml-auto text-center">
                            <LoaderedButton type="submit" :clickHandler="submitForm" btnClasses="btn btn-primary" :content="'Reset Password' | translate" :isValid="isValid"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import PasswordHandler from '@C/PasswordHandler';
import widgetMixin from '@M/widgets/dialog';

export default {
    mixins: [widgetMixin],
    name: 'WidgetPasswordReset',
    computed: {
        ...mapState(['formSubmitting']),
        ...mapFields(`Auth`, ['current_password', 'currentPwordHidden'])
    },
    mounted() {
        // The password handler needs this to be present when checking if your new password is the same as your old password.
        this.$store.commit('Auth/email', this.user.email);
    },
    methods: {
        ...mapActions({
            formHandler: 'Widget/resetPassword'
        }),
        ...mapMutations({
            toggleCurrentPassword: 'Auth/toggleCurrentPassword'
        }),
    },
    components: {
        PasswordHandler
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/PasswordReset.vue